import React from 'react'

export const Noop = () => <></>
